function createShareUrl({ title, text }) {
  return `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text)}`
}

export default {
  id: 'email',
  title: 'Email',
  iconName: 'at',
  showLegalInfo: false,
  createShareUrl
}
